import { FlexBox } from '@common/FlexBox';
import {
  // CategoryOutlined,
  // ChecklistOutlined,
  Inventory2Outlined,
  InventoryOutlined,
  ListAltOutlined,
  LocationOn,
  SpaceDashboardOutlined,
} from '@mui/icons-material';
import { Box, IconButton, styled, useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { MobileMenu } from './MobileMenu';
import { SettingsPopup } from './SettingsPopup';
import { useEffect, useMemo, useState } from 'react';
import { useGateValue } from '@statsig/react-bindings';

const MenuButton = styled(IconButton)`
  border-radious: 8px;
  paddingd: 0px;
  width: 40px;
`;

// Should be configurable

const menuConfig = [
  {
    text: 'Dashboard',
    icon: <SpaceDashboardOutlined />,
    path: '/dashboard',
  },
  {
    text: 'Products',
    icon: <Inventory2Outlined />,
    path: '/products/all-products',
  },
  { text: 'Locations', icon: <LocationOn />, path: '/locations/all-locations' },
  { text: 'Stocks', icon: <InventoryOutlined />, path: '/stocks/all-stocks' },
  // { text: 'Categories', icon: <CategoryOutlined />, path: '/categories' },
  // { text: 'Logs', icon: <ChecklistOutlined />, path: '/logs' },
  { text: 'Trades', icon: <ListAltOutlined />, path: '/trades/all-trades' },
];

export function MainMenu() {
  const navigate = useNavigate();
  const theme = useTheme();
  const [activeRoute, setActiveRoute] = useState('');
  const location = useLocation();

  const tradesEnabled = useGateValue('trades');

  const menuConfigWithTrades = useMemo(() => {
    return tradesEnabled
      ? menuConfig
      : menuConfig.filter((config) => config.text !== 'Trades');
  }, [tradesEnabled]);

  const activeButtonStyle = {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.primary,
  };

  useEffect(() => {
    const path = location.pathname === '/' ? '/products' : location.pathname;
    setActiveRoute(path);
  }, [location.pathname]);

  return (
    <>
      <MobileMenu menuConfig={menuConfigWithTrades} />
      <SideMenu>
        <FlexBox
          vertical
          spaceBetween
          style={{ height: '100%', paddingBottom: 12, alignItems: 'center' }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            {menuConfigWithTrades.map((config) => {
              const isRouteActive = config.path === activeRoute;
              const style = isRouteActive ? activeButtonStyle : {};
              return (
                <MenuButton
                  sx={style}
                  key={config.text}
                  onClick={() => {
                    navigate(config.path);
                    setActiveRoute(config.path);
                  }}
                >
                  {config.icon}
                </MenuButton>
              );
            })}
          </Box>
          <SettingsPopup />
        </FlexBox>
      </SideMenu>
    </>
  );
}

const SideMenu = styled('div')(({ theme }) => ({
  borderRight: `.5px solid  ${theme.palette.divider} `,
  justifyContent: 'space-between',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: 2,
  width: 53,
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
  '@media (max-width: 768px)': {
    display: 'none',
  },
}));
